module.exports = __webpack_public_path__ + "static/media/option3-4row.f830a960.png";